<ion-app [class.dark]="(darkmode.isDarkmode | async)" [class.light]="(darkmode.isDarkmode | async) === false">
  <ion-router-outlet></ion-router-outlet>
</ion-app>
<afs-confirm></afs-confirm>